import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { styled } from '@mui/styles';
import { PmiButton } from 'shell/components/shared/button';
import { memo } from 'react';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

interface ModalMessageProps {
  open: boolean;
  onClose: () => void;
}

const ModalMessageComponent = ({ open, onClose }: ModalMessageProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      fullScreen={fullScreen}
      open={open}
      onClose={() => {
        onClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
        Operazione eseguita
      </PmiDialogTitle>
      <DialogContent
        style={{
          padding: '30px 24px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        Pratica inviata ad ANPR in attesa di esito
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="contained"
          color="primary"
          onClick={() => {
            onClose();
          }}
        >
          Conferma
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalMessageComponent.displayName = 'Modal Message Component';

const ModalMessage = memo(ModalMessageComponent);

export default ModalMessage;
